module.exports = __webpack_public_path__ + "img/image_1.e66e3b8e.png";